import { mountEnvBanner } from './env-banner';
import Vue from 'vue'
import VueRouter from 'vue-router'
import SvgIcon from 'vue-svgicon'
import Velocity from 'velocity-animate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueApexCharts from 'vue-apexcharts'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import AsyncComputed from 'vue-async-computed'
import VueLodash from 'vue-lodash'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

import store from './store.js'



import Drag from './components/Drag'
import Drop from './components/Drop'

Vue.component('drag', Drag);
Vue.component('drop', Drop);



import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents)


// Prototypes?

import Date from './components/prototypes/Date'






// Components
import Page from './components/Page'
import SideWindow from './components/SideWindow'

Vue.component('page', Page);
Vue.component('side-window', SideWindow);

// Views
import ButtonView from './components/views/ButtonView'
import CheckView from './components/views/CheckView'
import ClockPopupView from './components/views/ClockPopupView'
import ClockSelectView from './components/views/ClockSelectView'
import ClockView from './components/views/ClockView'
import ContextPopupView from './components/views/ContextPopupView'
import DatePickerView from './components/views/DatePickerView'
import DateSelectView from './components/views/DateSelectView'
import DragSourceView from './components/views/DragSourceView'
import DragTargetView from './components/views/DragTargetView'
import IconButtonView from './components/views/IconButtonView'
import FullIconButtonView from './components/views/FullIconButtonView'
import ImageButtonView from './components/views/ImageButtonView'
import ListView from './components/views/ListView'
import NavigationView from './components/views/NavigationView'
import MobileNavigationView from './components/views/MobileNavigationView'
import ObjectSearchView from './components/views/ObjectSearchView'
import PageTabsView from './components/views/PageTabsView'
import PhotoView from './components/views/PhotoView'
import PopupView from './components/views/PopupView'
import SearchBarView from './components/views/SearchBarView'
import SelectView from './components/views/SelectView'
import StatusView from './components/views/StatusView'
import StringView from './components/views/StringView'
import NumberView from './components/views/NumberView'
import SimpleNumberView from './components/views/SimpleNumberView'
import SwitchView from './components/views/SwitchView'
import SwitchArrayView from './components/views/SwitchArrayView'
import TableView from './components/views/TableView'
import TabsView from './components/views/TabsView'
import TextView from './components/views/TextView'
import EntitySelectView from './components/views/EntitySelectView'
import LazyEntitySelectView from './components/views/LazyEntitySelectView'
import AutoCompleteView from './components/views/AutoCompleteView'
import CheckListView from './components/views/CheckListView'
import ButtonGroupView from './components/views/ButtonGroupView'
import SpinnerView from './components/views/SpinnerView'
import WindowListView from './components/views/WindowListView'
import DatePickerStdView from './components/views/DatePickerStdView'
import YesNoView from './components/views/YesNoView'
import WhiteFileListView from './components/views/WhiteFileListView'
import TaskSelectView from './components/views/TaskSelectView'
import InfoView from './components/views/InfoView'
import ImageView from './components/views/ImageView'
import LoginImageView from './components/views/LoginImageView'
import PaginationView from './components/views/PaginationView'
import AlphabetView from './components/views/AlphabetView'
import PaginationBarView from './components/views/PaginationBarView'
import AnnotationView from './components/views/AnnotationView'
import Lottie from 'vue-lottie'
import lodash from "lodash"

Vue.component('task-select-view', TaskSelectView);
Vue.component('white-file-list-view', WhiteFileListView);
Vue.component('button-view', ButtonView);
Vue.component('yes-no-view', YesNoView);
Vue.component('date-picker-std-view', DatePickerStdView);
Vue.component('check-view', CheckView);
Vue.component('clock-popup-view', ClockPopupView);
Vue.component('clock-select-view', ClockSelectView);
Vue.component('clock-view', ClockView);
Vue.component('context-popup-view', ContextPopupView);
Vue.component('date-picker-view', DatePickerView);
Vue.component('date-select-view', DateSelectView);
Vue.component('drag-source-view', DragSourceView);
Vue.component('drag-target-view', DragTargetView);
Vue.component('icon-button-view', IconButtonView);
Vue.component('full-icon-button-view', FullIconButtonView);
Vue.component('image-button-view', ImageButtonView);
Vue.component('list-view', ListView);
Vue.component('navigation-view', NavigationView);
Vue.component('mobile-navigation-view', MobileNavigationView);
Vue.component('object-search-view', ObjectSearchView);
Vue.component('page-tabs-view', PageTabsView);
Vue.component('photo-view', PhotoView);
Vue.component('popup-view', PopupView);
Vue.component('search-bar-view', SearchBarView);
Vue.component('select-view', SelectView);
Vue.component('status-view', StatusView);
Vue.component('string-view', StringView);
Vue.component('number-view', NumberView);
Vue.component('simple-number-view', SimpleNumberView);
Vue.component('switch-view', SwitchView);
Vue.component('switch-array-view', SwitchArrayView);
Vue.component('table-view', TableView);
Vue.component('tabs-view', TabsView);
Vue.component('text-view', TextView);
Vue.component('entity-select-view', EntitySelectView);
Vue.component('lazy-entity-select-view', LazyEntitySelectView);
Vue.component('check-list-view', CheckListView);
Vue.component('button-group-view', ButtonGroupView);
Vue.component('spinner-view', SpinnerView);
Vue.component('window-list-view', WindowListView);
Vue.component('svg-icon', SvgIcon);
Vue.component('info-view', InfoView);
Vue.component('auto-complete-view', AutoCompleteView);
Vue.component('image-view', ImageView);
Vue.component('login-image-view', LoginImageView);
Vue.component('lottie-view', Lottie);
Vue.component('pagination-view', PaginationView);
Vue.component('alphabet-view', AlphabetView);
Vue.component('pagination-bar-view', PaginationBarView);
Vue.component('annotation-view', AnnotationView);

import PlethoraTabsView from './components/views/plethora/TabsView'
Vue.component('plethora-tabs-view', PlethoraTabsView);

// App
import App from './App.vue'

// Layouts
import FormGridLayout from './components/layouts/FormGridLayout'
import FormLineLayout from './components/layouts/FormLineLayout'
import PageContentLayout from './components/layouts/PageContentLayout'
import TabbedPageLayout from './components/layouts/TabbedPageLayout'

Vue.component('form-grid-layout', FormGridLayout);
Vue.component('form-line-layout', FormLineLayout);
Vue.component('page-content-layout', PageContentLayout);
Vue.component('tabbed-page-layout', TabbedPageLayout);



import HomeLayout from './components/layouts/HomeLayout'

import SalesLayout from './components/layouts/SalesLayout'
import PlanningLayout from './components/layouts/PlanningLayout'
import FleetLayout from './components/layouts/FleetLayout'
import TrackingLayout from './components/layouts/TrackingLayout'
import WorkforceLayout from './components/layouts/WorkforceLayout'
import WarehouseLayout from './components/layouts/WarehouseLayout'
import BoxesLayout from './components/layouts/BoxesLayout'
import ClaimsLayout from './components/layouts/ClaimsLayout'
import AccountingLayout from './components/layouts/AccountingLayout'

// Pages
import DashboardPage from './components/pages/DashboardPage'

import LoginPage from './components/pages/LoginPage'
import ClaimFormPage from './components/pages/ClaimFormPage'
import NotFoundPage from './components/pages/NotFoundPage'

import SalesLeadsPage from './components/pages/SalesLeadsPage'
import SalesProductsPage from './components/pages/SalesProductsPage'
import SalesProductGroupsPage from './components/pages/SalesProductGroupsPage'
import SalesQuotesPage from './components/pages/SalesQuotesPage'
import SalesOrdersPage from './components/pages/SalesOrdersPage'
import SalesStatisticsPage from './components/pages/SalesStatisticsPage'

import PlanningCalendarPage from './components/pages/PlanningCalendarPage'
import PlanningJobsPage from './components/pages/PlanningJobsPage'

import FleetTrackingPage from './components/pages/FleetTrackingPage'
import FleetVehiclesPage from './components/pages/FleetVehiclesPage'
import FleetTrackerListPage from './components/pages/FleetTrackerListPage'
import FleetGeofencingPage from './components/pages/FleetGeofencingPage'

import WorkforceLeavePage from './components/pages/WorkforceLeavePage'
import HoursPage from './components/pages/HoursPage'
import WorkforceEmployeesPage from './components/pages/WorkforceEmployeesPage'
import WorkforceStatisticsPage from './components/pages/WorkforceStatisticsPage'

import WarehouseOverviewPage from './components/pages/WarehouseOverviewPage'
import WarehouseUnitsPage from './components/pages/WarehouseUnitsPage'
import WarehouseLocationsPage from './components/pages/WarehouseLocationsPage'

import BoxesStatusPage from './components/pages/BoxesStatusPage'
import BoxesStatisticsPage from './components/pages/BoxesStatusPage'

import ClaimsCasesPage from './components/pages/ClaimsCasesPage'
import ClaimsStatisticsPage from './components/pages/ClaimsStatisticsPage'
import FraudPage from './components/pages/FraudPage'
import FraudRulesPage from './components/pages/FraudRulesPage'
import FraudLayout from './components/layouts/FraudLayout'

import LogPage from './components/pages/LogPage'
import CustomersPage from './components/pages/CustomersPage'
import CustomerDetailPage from './components/pages/CustomerDetailPage'

import InvoicingPage from './components/pages/InvoicingPage'
import AccountingPage from './components/pages/AccountingPage'

import NewsPage from './components/pages/NewsPage'



import './icons'

Vue.config.productionTip = false

Vue.use(VueLodash, { lodash: lodash })
Vue.use(PerfectScrollbar);
Vue.use(AsyncComputed);
Vue.use(VueAxios, axios);
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(SvgIcon);
Vue.use(VueApexCharts);
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyBWFdFuwQsDApcRbwxJTAZUitlFrXjbRXw',
		libraries: 'places'
	}
});

Vue.component('apexchart', VueApexCharts);

Object.defineProperty(Vue.prototype, '$velocity', { value: Velocity });








Vue.directive('focus', {
    inserted: function (el) {
        el.focus()
    }
})






Vue.filter('optional', function (value) {
	return value === null ? '-' : value;
});

Vue.filter('date', function (value) {
	if (value == null) return '';
	var d = Date.normDate(value);

	return d.format('d-m-Y');
});

Vue.filter('timestamp', function (value) {
	if (value == null) return '';

	var d = Date.normDate(value);

	return d.format('d-m-Y, kl H:i');
});

Vue.filter('time', function (value) {
	if (isNaN(value)) return value;

	// Hours
	let hr = Math.floor(value / 60);

	// Minutes
	let min = value % 60;

	return hr.toString().padStart(2, '0') + ':' + min.toString().padStart(2, '0');
});

Vue.filter('extractTime', function (value) {
	if (value == null) return '';
	var d = Date.normDate(value);

	//

	return d.format('H:i');
});

Vue.filter('roundHours', function (value) {
	// HD is rounded to half hours
	const mul = 1.0 / 0.25;
	const r = Math.round(value * mul) / mul;

	return r;
});

Vue.filter('formatHours', function (value) {
	const v = parseFloat(value);
	const t = Math.floor(v);
	return t + ' t ' + (Math.floor((v - t) * 60)).toString().padStart(2, '0') + ' m';
});

Vue.filter('duration', function (value) {
	var t = Math.floor(value / 60);
	return t + (t == 1 ? ' time ' : ' timer ') + (value % 60) + ' min';
});

Vue.filter('integer', function (value) {
	return new Intl.NumberFormat('da-DK', {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	}).format(value);
});

Vue.filter('number', function (value, decimals) {
	return new Intl.NumberFormat('da-DK', {
		minimumFractionDigits: decimals !== undefined ? decimals : 2,
		maximumFractionDigits: decimals !== undefined ? decimals : 2
	}).format(value);
});

Vue.filter('translate', function (value) {
	var dict = {
		'individual': 'Individual',
		'business': 'Business'
	};

	return dict[value];
});

Vue.filter('float', function (value) {
	return value;
});

Vue.filter('wrapDecimal', function (value) {
	return value.toString().replace('.', ',');
});

Vue.filter('unwrapDecimal', function (value) {
	return value.toString().replace(',', '.');
});

Vue.filter('days', function (value) {
	var now = new Date();
	var d 	= new Date(value);
	var n 	= Math.floor(Math.round(d - now) / (24 * 60 * 60 * 1000));
	var a 	= Math.abs(n);
	
	var s 	= '';

	if (n < -1) 	s = a + ' dage siden';
	if (n == - 1) 	s = 'I går';
	if (n == 0) 	s = 'I dag';
	if (n == 1)		s = 'I morgen';
	if (n > 1)		s = 'Om ' + a + ' dage';

	return s;
});

Vue.filter('striphtml', function (value) {
	if (!value) return '';
	return value.replace(/<\/?[^>]+>/ig, ""); 
});






Vue.directive('$model', {
    bind: function (el, binding, vnode) {
        el.oninput = () => (vnode.context[binding.expression] = el.value)
    }
})

// Interceptor
const axiosInterceptor = (config) => {
	config.params = {
		'_cache': (new Date()).getTime()
	};

	//config.headers.Authorization = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJtb292ciIsImF1ZCI6Im1vb3ZyIiwiaWF0IjoxNTY2OTQwNTYyLCJ1aWQiOjEsImNpZCI6MX0.aJ2hGmbzmO1l5zNZtdplEljybf9varcuAJNmYUt10Yg';

	//config.headers.AccessControlAllowOrigin = '*';

	if (store.state.auth) {
		config.headers.Authorization = 'Bearer ' + store.state.auth;
	}

	return config;
};

// Base setup
const configAxios = (a) => {
	// iOS fix
	a.defaults.headers.common['Cache-Control'] = 'no-cache';

	a.defaults.baseURL = process.env.VUE_APP_API;
	a.interceptors.request.use(axiosInterceptor);
};

// Cache adapter
const requestCacheSize = 50;
let requestCache = new Map();

const defaultAdapter = axios.defaults.adapter;

axios.defaults.adapter = function (config) {
	

	return new Promise((resolve, reject) => {
		const fingerPrint = `${config.method}:${config.url}:${JSON.stringify(config.params)}:${JSON.stringify(config.data)}`;

		function resolveAttachments() {
			const c = requestCache.get(fingerPrint);

			if (c && c.response) {
				for (const attachment of c.attachments) {
					attachment(c.response);
				}

				c.attachments = [];
			}

			// Cleanup cache - evict only the oldest SETTLED entries beyond the cap.
			// Never evict an entry that is still in flight (response === null), or its
			// attached duplicates would be stranded and never resolve.
			let keys = Array.from(requestCache.keys());
			let n = Math.max(0, keys.length - requestCacheSize);

			for (const key of keys) {
				if (n <= 0) break;
				const entry = requestCache.get(key);
				if (entry && entry.response !== null) {
					requestCache.delete(key);
					--n;
				}
			}
		}

		function cache(response) {
			const c = requestCache.get(fingerPrint);
			if (!c) return;
			c.response = response;
			resolveAttachments();
		}

		function fetch() {
			requestCache.set(fingerPrint, {
				attachments: [],
				response: null,
			});

			let axiosWithoutAdapter = axios.create(Object.assign(config, { adapter: defaultAdapter }));
			configAxios(axiosWithoutAdapter);

			axiosWithoutAdapter.request(config)
				.then(response => {
					resolve(response);

					// Cache and resolve attachments
					cache(response);
				})
				.catch(error => reject(error));
		}

		function attach() {
			

			let c = requestCache.get(fingerPrint);

			c.attachments.push((response) => {
				
				resolve(response);
			});

			resolveAttachments();
		}

		// Attach duplicate requests to same response
		if (requestCache.has(fingerPrint)) {
			return attach();
		} else {
			return fetch();
		}
	});
};

configAxios(axios);









function auth({next, router}) {
	

	if (store.state.auth) {
		

		// Also load on page change
		store.dispatch('update_settings', axios);

		return next();
	}	

	// Try to get in using local storage
	
	if (localStorage.auth) {
		store.commit('auth', localStorage.auth);

		axios
			.get('/me/')
			.then(function (r) {
				if (r.data.privileges.web_login) {
					store.commit('employee', r.data);
					store.commit('department', r.data._embedded.department);

					// Init data settings
					store.dispatch('update', axios);

					axios
						.get('/us/departments/')
						.then(function (r) {
							store.commit('departments', r.data._items);
						});
				}				
			});		

		return next();
	}

	

	return router.push({
		path: '/da/login'
	});
}



const meta = (label) => {
	return {
		middleware: auth,
		mobile: false,
		label: label
	};
};




const sales = [
	{
		label: 'Henvendelser',
		badge: 0,
		name: 'leads', 
		path: 'leads', 
		component: SalesLeadsPage,
		props: {
			root: 'sales'
		},
		meta: meta('Henvendelser')
	},
	{
		label: 'Tilbud',
		badge: 0,
		name: 'quotes', 
		path: 'quotes', 
		component: SalesQuotesPage,
		props: true,
		root: 'sales',
		meta: meta('Tilbud')
	},
	{
		label: 'Ordrer',
		badge: 0,
		name: 'orders', 
		path: 'orders', 
		component: SalesOrdersPage,
		props: true,
		root: 'sales',
		meta: meta('Ordrer')
	},
	{
		label: 'Varegrupper',
		badge: 0,
		name: 'product-groups', 
		path: 'product-groups', 
		component: SalesProductGroupsPage,
		props: true,
		root: 'sales',
		meta: meta('Varegrupper')
	},
	{
		label: 'Varer',
		badge: 0,
		name: 'products', 
		path: 'products', 
		component: SalesProductsPage,
		props: true,
		root: 'sales',
		meta: meta('Varer')
	},
	{
		label: 'Statistik',
		badge: 0,
		name: 'sales-statistics', 
		path: 'statistics', 
		component: SalesStatisticsPage,
		props: {
			root: 'sales'
		},
		meta: meta('Statistik')
	}
];

const planning = [
	{
		label: 'Kalender',
		badge: 0,
		name: 'calendar', 
		path: 'calendar', 
		component: PlanningCalendarPage,
		props: {
			root: 'planning'
		},
		meta: meta('Kalender')
	},
	/*{
		label: 'Reservationer',
		badge: 0,
		name: 'reservations', 
		path: 'reservations', 
		component: PlanningReservationsPage,
		props: {
			root: 'planning'
		},
		meta: meta
	},*/
	{
		label: 'Opgaver',
		badge: 0,
		name: 'jobs', 
		path: 'jobs', 
		component: PlanningJobsPage,
		props: {
			root: 'planning'
		},
		meta: meta('Opgaver')
	}
];

const fleet = [
	{
		label: 'Køretøjer',
		badge: 0,
		name: 'vehicles', 
		path: 'vehicles', 
		component: FleetVehiclesPage,
		props: {
			root: 'fleet'
		},
		meta: meta('Køretøjer')
	}
];

const tracking = [
	{
		label: 'Kort',
		badge: 0,
		name: 'map', 
		path: 'map', 
		component: FleetTrackingPage,
		props: {
			root: 'tracking'
		},
		meta: {...meta('Kort'), ...{
			mobile: true
		}}
	},
	{
		label: 'Geofencing',
		badge: 0,
		name: 'geofencing', 
		path: 'geofencing', 
		component: FleetGeofencingPage,
		props: {
			root: 'fleet'
		},
		meta: meta('Geofencing')
	},
	{
		label: 'Trackere',
		badge: 0,
		name: 'trackers', 
		path: 'trackers', 
		component: FleetTrackerListPage,
		props: {
			root: 'fleet'
		},
		meta: meta('Trackere')
	}
];

const workforce = [
	/*{
		label: 'Fravær',
		badge: 0,
		name: 'leave', 
		path: '/workforce/leave', 
		component: WorkforceLeavePage,
		props: {
			root: 'workforce'
		},
		meta: meta
	},*/
	{
		label: 'Medarbejdere',
		badge: 0,
		name: 'employees', 
		path: 'employees', 
		component: WorkforceEmployeesPage,
		props: {
			root: 'workforce'
		},
		meta: meta('Medarbejdere')
	},
	{
		label: 'Fravær',
		badge: 0,
		name: 'leave', 
		path: 'leave', 
		component: WorkforceLeavePage,
		props: {
			root: 'workforce'
		},
		meta: meta('Fravær')
	},
	{
		label: 'Timer',
		badge: 0,
		name: 'hours', 
		path: 'hours', 
		component: HoursPage,
		props: {
			root: 'workforce'
		},
		meta: meta('Timer')
	},
	{
		label: 'Statistik',
		badge: 0,
		name: 'employees-statistics', 
		path: 'statistics', 
		component: WorkforceStatisticsPage,
		props: {
			root: 'workforce'
		},
		meta: meta('Statistik')
	}
];

const warehouse = [
	{
		label: 'Oversigt',
		badge: 0,
		name: 'warehouse-dash', 
		path: 'dashboard', 
		component: WarehouseOverviewPage,
		props: {
			root: 'warehouse'
		},
		meta: meta('Oversigt')
	},
	{
		label: 'Lokationer',
		badge: 0,
		name: 'locations', 
		path: 'locations', 
		component: WarehouseLocationsPage,
		props: {
			root: 'warehouse'
		},
		meta: meta('Lokationer')
	},
	/*{
		label: 'Udlejning', 
		badge: 0,
		name: 'contracts', 
		path: 'contracts', 
		component: WarehouseContractsPage,
		props: {
			root: 'warehouse'
		},
		meta: meta
	},*/
	{
		label: 'Enheder',
		badge: 0,
		name: 'units', 
		path: 'units', 
		component: WarehouseUnitsPage,
		props: {
			root: 'warehouse'
		},
		meta: meta('Enheder')
	}
];

const boxes = [
	{
		label: 'Udestående',
		badge: 0,
		name: 'boxes-status', 
		path: 'status', 
		component: BoxesStatusPage,
		props: {
			root: 'boxes'
		},
		meta: meta('Udestående')
	},
	{
		label: 'Statistik',
		badge: 0,
		name: 'box-statistics', 
		path: 'statistics', 
		component: BoxesStatisticsPage,
		props: {
			root: 'boxes'
		},
		meta: meta('Statistik')
	}
];

const claims = [
	{
		label: 'Sager',
		badge: 0,
		name: 'cases', 
		path: 'cases', 
		component: ClaimsCasesPage,
		props: {
			root: 'claims'
		},
		meta: meta('Sager')
	},
	{
		label: 'Statistik',
		badge: 0,
		name: 'claims-statistics', 
		path: 'statistics', 
		component: ClaimsStatisticsPage,
		props: {
			root: 'claims'
		},
		meta: meta('Statistik')
	}
];

const fraud = [
	{
		label: 'Alarmer',
		badge: 0,
		name: 'fraud-alarms',
		path: 'alarms',
		component: FraudPage,
		props: {
			root: 'fraud'
		},
		meta: meta('Alarmer')
	},
	{
		label: 'Regler',
		badge: 0,
		name: 'fraud-rules',
		path: 'rules',
		component: FraudRulesPage,
		props: {
			root: 'fraud'
		},
		meta: meta('Regler')
	}
];

const finances = [
	{
		label: 'Fakturering',
		badge: 0,
		name: 'invoicing', 
		path: 'invoicing', 
		component: InvoicingPage,
		props: {
			root: 'finances'
		},
		meta: meta('Fakturering')
	},
	{
		label: 'Bogføring',
		badge: 0,
		name: 'accounting',
		path: 'accounting',
		component: AccountingPage,
		props: {
			root: 'finances'
		},
		meta: meta('Bogføring')
	},
];

const availablePages = [
	{
		label: 'Oversigt',
		badge: 0,
		icon: 'ecg',
		name: 'dashboard', 
		path: 'dashboard', 
		module: null,
		component: DashboardPage,
		props: true,
		children: null,
		meta: {...meta('Oversigt'), ...{
			mobile: true
		}}
	},
	/*{
		label: 'Kontakter',
		badge: 0,
		icon: 'contacts',
		name: 'contacts', 
		path: 'contacts', 
		component: ContactsPage,
		props: true,
		meta: meta
	},*/
	{
		label: 'Salg',
		badge: 0,
		icon: 'sales',
		name: 'sales', 
		path: 'sales', 
		module: null,
		component: SalesLayout,
		redirect: {
			name: sales[0].name
		},
		props: { pages: sales },
		children: sales,
		meta: meta('Salg')
	},
	{
		label: 'Planlægning',
		badge: 0,
		icon: 'calendar',
		name: 'planning', 
		path: 'planning', 
		module: null,
		component: PlanningLayout,
		redirect: {
			name: planning[0].name
		},
		props: { pages: planning },
		children: planning,
		meta: meta('Planlægning')
	},
	{
		label: 'Tracking',
		badge: 0,
		icon: 'tracking',
		name: 'tracking', 
		path: 'tracking', 
		module: 'tracking',
		component: TrackingLayout,
		redirect: {
			name: tracking[0].name
		},
		props: { pages: tracking },
		children: tracking,
		meta: {...meta('Tracking'), ...{
			mobile: true
		}}
	},
	{
		label: 'Flåde',
		badge: 0,
		icon: 'truck',
		name: 'fleet', 
		path: 'fleet', 
		module: null,
		component: FleetLayout,
		redirect: {
			name: fleet[0].name
		},
		props: { pages: fleet },
		children: fleet,
		meta: meta('Flåde')
	},
	{
		label: 'Arbejdsstyrke',
		badge: 0,
		icon: 'user',
		name: 'workforce',
		path: 'workforce',
		module: null,
		component: WorkforceLayout,
		redirect: {
			name: workforce[0].name
		},
		props: { pages: workforce },
		children: workforce,
		meta: meta('Arbejdsstyrke')
	},
	{
		label: 'Bedrageri',
		badge: 0,
		icon: 'warning',
		name: 'fraud',
		path: 'fraud',
		module: null,
		component: FraudLayout,
		redirect: {
			name: fraud[0].name
		},
		props: { pages: fraud },
		children: fraud,
		meta: meta('Bedrageri')
	},
	{
		label: 'Lager',
		badge: 0,
		icon: 'warehouse',
		name: 'warehouse', 
		path: 'warehouse', 
		module: 'storage',
		component: WarehouseLayout,
		redirect: {
			name: warehouse[0].name
		},
		props: { pages: warehouse },
		children: warehouse,
		meta: meta('Lager'),
		//mode: 'development'
	},
	{
		label: 'Emballage',
		badge: 0,
		icon: 'box',
		name: 'boxes', 
		path: 'boxes', 
		module: null,
		component: BoxesLayout,
		redirect: {
			name: boxes[0].name
		},
		props: { pages: boxes },
		children: boxes,
		meta: meta('Emballage')
	},
	{
		label: 'Skader',
		badge: 0,
		icon: 'damage',
		name: 'claims', 
		path: 'claims', 
		module: 'claims',
		component: ClaimsLayout,
		redirect: {
			name: claims[0].name
		},
		props: { pages: claims },
		children: claims,
		meta: meta('Skader')
	},
	{
		label: 'Regnskab',
		badge: 0,
		icon: 'dollar',
		name: 'finances', 
		path: 'finances', 
		module: null,
		component: AccountingLayout,
		redirect: {
			name: finances[0].name
		},
		props: { pages: finances },
		children: finances,
		meta: meta('Regnskab')
	},
	{
		label: 'Nyheder',
		badge: 0,
		icon: 'bell',
		name: 'news', 
		path: 'news', 
		module: null,
		component: NewsPage,
		props: true,
		children: null,
		meta: meta('Nyheder')
	},
	{
		label: 'Kunder',
		badge: 0,
		icon: 'support',
		name: 'customers', 
		path: 'customers', 
		module: null,
		component: CustomersPage,
		props: true,
		children: null,
		meta: meta('Kunder')
	},
	{
		label: 'Log',
		badge: 0,
		icon: 'calendar',
		name: 'log', 
		path: 'log', 
		module: null,
		component: LogPage,
		props: true,
		children: null,
		meta: meta('Log')
	},
	{
		label: 'Indstillinger',
		badge: 0,
		icon: 'settings',
		pos: 'bottom',
		name: 'settings', 
		path: 'settings', 
		module: null,
		props: true,
		children: null,
		meta: meta('Indstillinger')
	}
];

var pages = [];

for (var i = 0; i < availablePages.length; ++i) {
	

	if ((!availablePages[i].mode) || availablePages[i].mode == process.env.NODE_ENV) {
		pages.push(availablePages[i]);
		
	}
}

const router = new VueRouter({
	//base: '/:customer/:lang/',
	mode: 'history',
	routes: [
		{
			path: '/',
			redirect: {
				path: '/da'
			}
		},
		{
			path: '/:lang',
			name: 'home',
			component: HomeLayout,
			redirect: {
				name: 'dashboard'
			},
			children: pages.concat([
				{
					name: 'login',
					path: 'login',
					component: LoginPage,
					meta: {
						label: 'Login'
					}
				},
				{
					name: 'public_claims',
					path: 'public/claims/:id',
					component: ClaimFormPage
				},
				{
					name: 'customer-detail',
					path: 'customers/:id',
					component: CustomerDetailPage,
					meta: meta('Kunde')
				}
			])
		},
		{
			path: '*',
			component: NotFoundPage
		}
	]
});








// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
	const subsequentMiddleware = middleware[index];
	// If no subsequent Middleware exists,
	// the default `next()` callback is returned.
	if (!subsequentMiddleware) return context.next;

	return (...parameters) => {
	// Run the default Vue Router `next()` callback first.
	context.next(...parameters);
	// Then run the subsequent Middleware with a new
	// `nextMiddleware()` callback.
	const nextMiddleware = nextFactory(context, middleware, index + 1);
		subsequentMiddleware({ ...context, next: nextMiddleware });
	};
}









router.beforeEach((to, from, next) => {
	//

	if (to.meta.middleware) {
		const middleware = Array.isArray(to.meta.middleware)
		? to.meta.middleware
		: [to.meta.middleware];

		const context = {
			from,
			next,
			router,
			to,
		};
		const nextMiddleware = nextFactory(context, middleware, 1);

		return middleware[0]({ ...context, next: nextMiddleware });
	}

	return next();
});

router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
		
        document.title = to.matched.length >= 2 ? to.matched[1].meta.label + ' - Moovr' : 'Moovr';
    });
});









const tester = {
	explode: function () {
		
	}
};









var event = function (event) {
	
	

	if (!(el == event.target || el.contains(event.target))) {
		vnode.context[binding.expression](event);
	}
};


Vue.directive('click-outside', {
	priority: 700,
	bind(el, binding, vnode) {
		document.addEventListener('click', event);
	},
	unbind(el) {
		document.removeEventListener('click', event);
	}
});





new Vue({
	el: '#app',
	render: h => h(App, {
		props: {
			langCode: 'da',
			pages: pages
		}
	}),
	router,
	store
});

mountEnvBanner(process.env.VUE_APP_API);
